import { useState, forwardRef } from "react";

import { FormControl as Input, Button, Form } from "react-bootstrap";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Icon } from "../../components/common/Icon";
import { Attention } from "./Attention";

type PasswordInputProps = {
    label?: string;
    placeholder?: string;
    className?: string;
    required?: boolean;
    width?: string;
    [key: string]: any;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
    const [show, setShow] = useState(false);
    
    // Extrair props específicas para nosso componente
    const { 
        label, 
        placeholder, 
        className = "", 
        required, 
        width = "100%", 
        ...inputProps 
    } = props;

    return(
        <div className="password-group margin-bottom" style={{width: width}}>
            <Form.Label>{label} {required && <Attention/>}</Form.Label>
            <div className="fdrow flex">
                <Input 
                    type={(show ? "text" : "password")} 
                    placeholder={placeholder} 
                    className={className + " flex1"}
                    required={required}
                    autoComplete="new-password"
                    ref={ref}
                    {...inputProps}
                    style={{
                        borderTopLeftRadius: "7px",
                        borderBottomLeftRadius: "7px",
                        borderTopRightRadius: "0px",
                        borderBottomRightRadius: "0px",
                        fontSize:14
                    }}
                />
                <Button 
                    type="button"
                    onClick={() => setShow(!show)}                    style={{
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderTopRightRadius: "7px",
                        borderBottomRightRadius: "7px",
                        background:'white',
                        borderColor:'rgb(98, 110, 212)'
                    }}
                >{(show ? <Icon icon={AiFillEyeInvisible} color='rgb(98, 110, 212)'/> : <Icon icon={AiFillEye} color='rgb(98, 110, 212)'/>)}</Button>
            </div>
        </div>
    );
});

export default PasswordInput;